import { createBrowserRouter } from "react-router";

export const router = createBrowserRouter([
	{
		path: "/",
		lazy: () => import("../routes/root"),
		HydrateFallback: () => null,
		children: [
			{
				index: true,
				lazy: () => import("../routes/_index"),
			},
			{
				path: "org",
				lazy: () => import("../routes/org._index/route"),
			},
			{
				path: "project",
				lazy: () => import("../routes/project._index/route"),
			},
			{
				path: "project/new",
				lazy: () => import("../routes/project.new/route"),
			},
			{
				path: "project/:projectId",
				lazy: () => import("../routes/project.$projectId/route"),
				children: [
					{
						path: "layout/:layoutId",
						lazy: () =>
							import("../routes/project.$projectId.layout.$layoutId/route"),
					},
				],
			},
			{
				path: "*",
				lazy: () => import("../routes/$"),
			},
		],
	},
]);
